/**
 * Methods for dealing with currency and display
 */

export function currentLocale() {
  return window.locale;
}
